import { getClinicAPI } from "@client/clinic/getClinicAPI";
import { useQuery } from "@tanstack/react-query";

import { clinicKeys } from "./clinicKeys";
import type { QueryOptions } from "@hooks/queries/types";

export const useFetchClinicQuery = (options?: QueryOptions) => {
  const { data, ...rest } = useQuery({
    queryKey: clinicKeys.clinic(),
    queryFn: getClinicAPI,
    ...options,
  });
  return { clinic: data?.data, ...rest };
};
